import { AlignJustify, Equal, Rows3 } from 'lucide-react';
import { type Density, DENSITY_LABELS, useTheme } from '#client/providers/ThemeProvider';
import { Segmented } from './Segmented';

/**
 * Row height for every table in the app: 32 / 40 / 48px.
 *
 * Deliberately a global preference rather than a per-table prop. An operator
 * who wants dense rows wants them everywhere, and mixing densities across
 * screens reads as inconsistency rather than as flexibility. The value lives on
 * `<html data-density>` and is consumed purely in CSS — see `--row-h` in
 * theme/tailwind-theme.css.
 *
 * It sits in the table toolbar rather than in a settings screen, because that
 * is where the effect is visible while you change it.
 */
const OPTIONS: { value: Density; label: string; icon: React.ReactNode }[] = [
  { value: 'compact', label: DENSITY_LABELS.compact, icon: <AlignJustify /> },
  { value: 'default', label: DENSITY_LABELS.default, icon: <Equal /> },
  { value: 'comfortable', label: DENSITY_LABELS.comfortable, icon: <Rows3 /> },
];

export function DensityControl() {
  const { density, setDensity } = useTheme();

  return (
    <Segmented
      label="Row density"
      options={OPTIONS}
      value={density}
      onChange={setDensity}
      iconOnly
      size="sm"
    />
  );
}
